import Vue from 'vue'
import VueRouter from 'vue-router'



import MainNavbar from "../layout/MainNavbar.vue";
import MainFooter from "../layout/MainFooter.vue";
import Account from "../views/Account";
import Color from "../views/Color";
import Auth from "../views/Auth";
import NotFound from "../views/components/NotFound";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'auth',
        component: () => import('../views/Auth.vue')
    },

    {
    path: '/account',
    name: 'Account',
    components: {default: Account, header: MainNavbar, footer: MainFooter},
        props: {
            header: {colorOnScroll:10},
            footer: {backgroundColor: "black"}
        },

   },

      {
        path: "/color",
        name: "Color",
        components: {default:Color, header: MainNavbar, footer: MainFooter},
            props: {
              header: {colorOnScroll: 100},
              footer: {backgroundColor: "black"}
            }

      },
    {
        path: "/reset-password/:token",
        name: "ResetPassword",
        components: {default:Auth, header: MainNavbar, footer: MainFooter},
        props: {
            header: {colorOnScroll: 100},
            footer: {backgroundColor: "black"}
        }

    },
        {
            path: '/404',
            name: '404',
            component: NotFound,
        },
        {
            path: '*',
            redirect: '/404'
        }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
    if (to.name === 'auth' && localStorage.getItem('token')) next({ name: 'Color' })
    else next()
})

export default router
